<template>
  <ReportChartCard :title="t('report.charts.utilization')">
    <VueApexCharts class="bg-white" type="bar" :options="chartOptions" :series="series" height="400" />
  </ReportChartCard>
</template>

<script setup lang="ts">
import { useI18n } from '@/composable/useI18n'
import { useReportStore } from '@/store/report'
import { useUtilizationChart } from '@/utils/components/utilization-chart'
import VueApexCharts from 'vue3-apexcharts'
import ReportChartCard from './ReportChartCard.vue'

const { t } = useI18n()
const store = useReportStore()

const { chartOptions, series } = useUtilizationChart(store.getEnergySensorUtilization, store.getCompareEnergySensorUtilization)
</script>
